import { Link } from "react-router-dom";
import { ArrowRight, BadgeIndianRupee, CalendarClock, Users } from "lucide-react";

export const JobCard = ({ job, index = 0 }) => {
  const open = job.applications_open && (!job.deadline || new Date(job.deadline + "T23:59:59") >= new Date());
  return (
    <article className="fade-up group flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl sm:p-8" style={{ animationDelay: `${index * 80}ms` }} data-testid={`job-card-${job.id}`}>
      <div className="mb-5 flex items-start justify-between gap-4">
        <h3 className="font-display text-xl font-bold leading-tight text-slate-900 sm:text-2xl" data-testid="job-card-title">{job.title}</h3>
        <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-bold ${open ? "bg-emerald-100 text-emerald-800" : "bg-slate-200 text-slate-600"}`}>{open ? "Open" : "Closed"}</span>
      </div>
      <dl className="mb-5 grid grid-cols-2 gap-3">
        <div className="rounded-xl bg-slate-50 p-3">
          <dt className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500"><Users className="h-3.5 w-3.5" /> Vacancies</dt>
          <dd className="font-mono-num mt-1 text-xl font-bold text-slate-900" data-testid="job-card-vacancies">{job.vacancies.toLocaleString("en-IN")}</dd>
        </div>
        <div className="rounded-xl bg-slate-50 p-3">
          <dt className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500"><BadgeIndianRupee className="h-3.5 w-3.5" /> Monthly salary</dt>
          <dd className="font-mono-num mt-1 text-base font-bold text-slate-900" data-testid="job-card-salary">{job.salary_text}</dd>
        </div>
      </dl>
      <p className="mb-1 text-sm font-semibold text-amber-700" data-testid="job-card-incentives">+ {job.incentives}</p>
      <p className="mb-5 text-sm leading-relaxed text-slate-600">{job.description}</p>
      <div className="mb-5 space-y-4 text-sm">
        <div><h4 className="mb-1 text-xs font-bold uppercase tracking-widest text-slate-500">Qualifications</h4><p className="text-slate-700">{job.qualifications}</p></div>
        <div>
          <h4 className="mb-1.5 text-xs font-bold uppercase tracking-widest text-slate-500">Skills</h4>
          <div className="flex flex-wrap gap-1.5">{job.skills.map((s) => <span key={s} className="rounded-full border border-slate-200 px-2.5 py-0.5 text-xs text-slate-700">{s}</span>)}</div>
        </div>
        <div>
          <h4 className="mb-1 text-xs font-bold uppercase tracking-widest text-slate-500">Responsibilities</h4>
          <ul className="list-disc space-y-0.5 pl-5 text-slate-700">{job.responsibilities.map((r) => <li key={r}>{r}</li>)}</ul>
        </div>
      </div>
      <div className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-5">
        <span className="flex items-center gap-1.5 text-xs text-slate-500" data-testid="job-card-deadline"><CalendarClock className="h-4 w-4" /> Apply by {job.deadline ? new Date(job.deadline).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—"}</span>
        {open ? (
          <Link to={`/apply?job=${job.id}`} className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-amber-600" data-testid={`job-apply-${job.id}`}>
            Apply Now <ArrowRight className="h-4 w-4" />
          </Link>
        ) : (
          <span className="text-sm font-semibold text-slate-400">Applications closed</span>
        )}
      </div>
    </article>
  );
};
